import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { RequestResponse, Upload } from '@/types';

export const uploadFile = async (
  payload: FormData,
  onUploadProgress?: (percent: number) => void,
  destination?: string
) => {
  const response = await axiosInstance.post<RequestResponse<Upload[]>>(
    endpoints.uploads,
    payload,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: destination ? { destination } : undefined,
      onUploadProgress: (event) => {
        if (!event.total || !onUploadProgress) return;
        onUploadProgress(Math.round((event.loaded * 100) / event.total));
      },
    }
  );
  return response.data;
};

export const deleteUpload = async (identifier: string | number) => {
  const response = await axiosInstance.delete<RequestResponse<Upload>>(
    `${endpoints.uploads}/${identifier}`
  );
  return response.data;
};
